import AvField from "availity-reactstrap-validation/lib/AvField"
import AvForm from "availity-reactstrap-validation/lib/AvForm"
import React, { useEffect, useState } from "react"
import { Card, CardBody, Col, Container, Label, Row } from "reactstrap"
import { Grid } from "react-loader-spinner"
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { withRouter } from "react-router-dom"
import PropTypes from "prop-types"
import cresusFond from "../../assets/images/prop1.png"
// Toastify
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import { Flip } from "react-toastify"
import APIS from "../../apis"
import { useParams } from "react-router-dom"
import axios from "axios"

const ResetPassword = props => {
  const [password, setPassword] = useState("")
  const [verifPassword, setVerifPassword] = useState("")
  const [loading, setLoading] = useState(true)
  const [annee, setAnnee] = useState("")
  const [anneeName, setAnneeName] = useState("")
  // Récupérer l'année au montage
  useEffect(() => {
    const fetchAnnee = async () => {
      try {
        const resA = await axios.get(
          "https://scolarite.backcresus-institut.ovh/api/annee/select"
        )
        const resAnnee = await axios.post(
          "https://scolarite.backcresus-institut.ovh/api/annee/get_by_id",
          { id: resA.data.Annee[0].CurrentAnnee[0].value }
        )

        setAnnee(resAnnee.data.Annee.id)
        setAnneeName(resAnnee.data.Annee.annee_scolaire)
      } catch (err) {
        console.error("Erreur lors de la récupération de l'année", err)
        toast.error("❌ Impossible de récupérer l'année scolaire", {
          containerId: "A",
        })
      }
    }

    fetchAnnee()
  }, [])
  const { token } = useParams()

  const save = async () => {
    setLoading(false)
    if (password == verifPassword) {
      const res = await APIS.post("changePasswordMastere", {
        password: password,
        token: token,annee_id:annee
      })
      if (res.data.status === 200) {
        toast.success(
          " Mot de passe a été modifier ",
          {
            containerId: "A",
          },
          props.history.push("/Redirection")
        )
      } else {
        setLoading(true)
        toast.error("⛔ Token expiré", {
          containerId: "A",
        })
      }
    } else {
      toast.error("⛔ Mot de passe incorrect", {
        containerId: "A",
      })
    }
  }

  return (
    <div>
      {loading ? (
        <div
          style={{
            backgroundImage: `url(${cresusFond})`,
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            backgroundPosition: "center",
            height: "100vh",
            width: "100vw",
          }}
        >
          <div style={{ paddingTop: "7%" }}>
            <Container>
              <Row className="justify-content-center">
                <Col md={8} lg={6} xl={5}>
                  <Card
                    style={{ backgroundColor: "#525351" }}
                    className="overflow-hidden"
                  >
                    <div>
                      <Row>
                        <Col className="justify-content-center pt-4">
                          <h1
                            style={{
                              color: "white",
                              textAlign: "center",
                            }}
                          >
                            Espace etudiant
                          </h1>
                        </Col>
                      </Row>
                    </div>
                    <CardBody className="pt-4">
                      <div className="p-2">
                        <AvForm className="form-horizontal">
                          <div className="mb-3">
                            <Label>Password</Label>
                            <AvField
                              name="password"
                              type="password"
                              placeholder="Password"
                              onChange={e => setPassword(e.target.value)}
                            />
                          </div>
                          <div className="mb-3">
                            <Label>Verifier password</Label>
                            <AvField
                              name="password1"
                              type="password"
                              placeholder={"Réécrire password"}
                              onChange={e => setVerifPassword(e.target.value)}
                            />
                          </div>
                          <div className="mt-3 d-grid">
                            <button
                              onClick={save}
                              className="btn btn-primary btn-block"
                              type="submit"
                            >
                              Confirmer
                            </button>
                          </div>
                        </AvForm>
                      </div>
                    </CardBody>
                    <div className="mt-1 text-center">
                      <p style={{ color: "white" }}>
                        © {new Date().getFullYear()} Cresus. Crafted with{" "}
                        <i
                          style={{ color: "white" }}
                          className="mdi mdi-heart text-danger"
                        />{" "}
                        by{" "}
                        <a
                          style={{ color: "white" }}
                          href="https://cresus.pro/"
                        >
                          cresus.pro
                        </a>
                      </p>
                    </div>
                  </Card>
                </Col>
              </Row>
            </Container>
            <ToastContainer
              transition={Flip}
              enableMultiContainer
              containerId={"A"}
              position={toast.POSITION.TOP_RIGHT}
              autoClose={2500}
            />
          </div>
        </div>
      ) : (
        <div
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            marginTop: "-50px",
            marginLeft: "-50px",
          }}
        >
          <Grid heigth="100" width="100" color="#86B5E9" ariaLabel="loading" />
        </div>
      )}
    </div>
  )
}

export default withRouter(ResetPassword)

ResetPassword.propTypes = {
  history: PropTypes.object,
  t: PropTypes.any,
}
